import { Observable } from 'rxjs';
var RxJsWebSocketService = /** @class */ (function () {
    function RxJsWebSocketService() {
    }
    RxJsWebSocketService.prototype.createObservableSocket = function (url) {
        var _this = this;
        this.ws = new WebSocket(url);
        return new Observable(function (observer) {
            _this.ws.onopen = function (event) { return observer.next('Connection with ' + url + ' is open'); };
            _this.ws.onmessage = function (event) { return observer.next('Receiving data from ' + url + ': ' + event.data); };
            _this.ws.onerror = function (event) { return observer.error(event); };
            _this.ws.onclose = function (event) { return observer.complete(); };
        });
    };
    RxJsWebSocketService.prototype.sendMessage = function (message) {
        if (this.ws) {
            console.log('Sending to the STB API: ' + JSON.stringify(message));
            this.ws.send(message);
        }
    };
    RxJsWebSocketService.prototype.isAvailable = function () {
        return this.ws && this.ws.readyState === WebSocket.OPEN;
    };
    return RxJsWebSocketService;
}());
export { RxJsWebSocketService };
